<template>
  <div class="page" :class="pagePosition" v-if="pages > 1">
    <ul>
      <!-- <li>
        <a @click="first" class="first-last">首页</a>
      </li>-->

      <li @click="prev">
        <a>
          <i class="ti-angle-left"></i>
        </a>
      </li>

      <li>
        <a :class="{ act: index === 1 }" @click="first" class="first-last">1</a>
      </li>

      <li v-if="showPrevMore">
        <span>···</span>
      </li>

      <li v-for="pager in pagers" :key="pager" @click="go(pager)">
        <a :class="{ act: index === pager }">{{ pager }}</a>
      </li>

      <li v-if="showNextMore">
        <span>···</span>
      </li>

      <li>
        <a :class="{ act: index === pages }" @click="last" class="first-last">{{
          pages
        }}</a>
      </li>

      <li @click="next">
        <a>
          <i class="ti-angle-right"></i>
        </a>
      </li>

      <!-- <li @click="last">
        <a class="first-last">尾页</a>
      </li>-->

      <li v-if="showTotalPage">共{{ pages }}页</li>

      <li v-if="showPageInput">
        <p>到</p>
        <input class="form-control" v-model.number="pager" />
        <p>页</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Page",
  props: {
    // 页面中的可见页码数，其他的以...替代, 必须是奇数
    perPages: {
      type: Number,
      default: 5,
    },
    // 当前页码
    pageIndex: {
      type: Number,
      default: 1,
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 5,
    },
    // 总记录数
    total: {
      type: Number,
      default: 1,
    },
    // 显示总页数
    showTotalPage: {
      type: Boolean,
      default: true,
    },
    // 显示跳转输入框
    showPageInput: {
      type: Boolean,
      default: true,
    },
    // 分页显示的位置: 中间center|左left|右right
    pagePosition: {
      type: String,
      default: "center",
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ["center", "left", "right"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      index: this.pageIndex, //当前页码
      limit: this.pageSize, //每页显示条数
      size: this.total || 1, //总记录数
      showPrevMore: false,
      showNextMore: false,
    };
  },
  methods: {
    prev() {
      if (this.index > 1) {
        this.go(this.index - 1);
      }
    },
    next() {
      if (this.index < this.pages) {
        this.go(this.index + 1);
      }
    },
    first() {
      if (this.index !== 1) {
        this.go(1);
      }
    },
    last() {
      if (this.index != this.pages) {
        this.go(this.pages);
      }
    },
    go(page) {
      if (this.index !== page) {
        this.index = page;
        // 父组件通过change方法来接受当前的页码
        this.$emit("change", this.index);
      }
    },
  },
  computed: {
    pager: {
      // 后期加防抖函数
      get: function () {
        return this.index;
      },
      set: function (newValue) {
        if (newValue && newValue >= 1 && newValue <= this.pages) {
          this.go(newValue);
        }
      },
    },
    // 计算总页码
    pages() {
      return Math.ceil(this.size / this.limit);
    },
    // 计算页码，当count等变化时自动计算
    pagers() {
      const array = [];
      const perPages = this.perPages;
      const pageCount = this.pages;
      let current = this.index;
      const _offset = (perPages - 1) / 2;

      const offset = {
        start: current - _offset,
        end: current + _offset,
      };

      if (offset.start < 1) {
        offset.end = offset.end + (1 - offset.start);
        offset.start = 1;
      }
      if (offset.end > pageCount) {
        offset.start = offset.start - (offset.end - pageCount);
        offset.end = pageCount;
      }
      if (offset.start < 1) offset.start = 1;

      this.showPrevMore = offset.start > 1;
      this.showNextMore = offset.end < pageCount;

      // 该列表中不显示第一页和最后一页，因为首页和尾页已经单独显示出来了
      for (let i = offset.start + 1; i <= offset.end - 1; i++) {
        array.push(i);
      }

      return array;
    },
  },
  watch: {
    pageIndex(val) {
      this.index = val || 1;
    },
    pageSize(val) {
      this.limit = val || 10;
    },
    total(val) {
      this.size = val || 1;
    },
  },
};
</script>

<style scoped>
/*分页*/
.disable {
  background-color: gray;
  color: #505050;
}
.first-last {
  padding: 0 5px;
}
.page {
  width: 100%;
  margin-top: 40px;
}
.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.page ul li {
  display: inline-block;
  margin: 0 2px;
}
.page ul li p {
  display: inline-block;
}
.page ul li .form-control {
  width: 50px;
  display: inline-block;
  margin: 0 5px;
  height: 30px;
}
.page ul li a,
.page ul li span {
  min-width: 30px;
  height: 30px;
  /* border: #ddd solid 1px; */
  display: block;
  text-align: center;
  line-height: 30px;
}
.page ul li a.act,
.page ul li a:hover {
  background: #006adf;
  /* border: #006adf solid 1px; */
  color: #fff;
}
</style>